/// <reference types="./libs/typescript/esnext.collection" />

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// all non-IE/Edge helps with fast event loop interactions
import "core-js/web/immediate";

// Safari & greenfield web workers
import "./libs/requestIdleCallback/ric";

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import "zone.js"; // Included with Angular-CLI.

// FIXME webpack5
globalThis["global"] = globalThis as any;
// globalThis["process"] = {
//   env: {
//     NODE_ENV: "production",
//     version: "16",
//     type: "browser"
//   },
//   argv: "node"
// } as any;
globalThis["process"] = require("process/browser");
